import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "appointmentContent"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w100 centered mt20" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs20 fw600" }, "ヘッダー画像を変更")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = {
  class: /*#__PURE__*/_normalizeClass(`w100 fr posRe `)
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "w600 fs13 pad10" }, "サンプル", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w100 centered" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/lisense_images",
    target: "_blank",
    class: "fs12 grey"
  }, "サンプル画像の著作権について")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "appointmentContent"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "w100 centered mt20" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs20 fw600" }, "出席者を選択")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "fr mt20"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "fw600 fl fs14",
  style: {"margin-top":"5px"}
}, "オーナーも日程調整に参加する   ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = {
  key: 1,
  class: "w100"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = {
  key: 3,
  class: "appointmentContent"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "w100 centered mt20" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs20 fw600" }, "調整可能時間・期間の設定")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = {
  key: 4,
  class: "appointmentContent"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["src"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = ["src"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "w100 centered mt20" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs20 fw600" }, "メッセージを編集")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = {
  key: 5,
  class: "appointmentContent"
}
const _hoisted_39 = {
  key: 6,
  class: "appointmentContent"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "w100 centered mt20" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs20 fw600" }, "場所を設定")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "fs13 fw600" }, "過去に利用した場所:", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = {
  key: 7,
  class: "appointmentContent"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "w100 centered mt20" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs20 fw600" }, "質問を編集")
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_50 = {
  key: 8,
  class: "appointmentContent"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "w100 centered mt20" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs20 fw600" }, "質問を追加")
], -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_53 = {
  key: 9,
  class: "appointmentContent"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "w100 centered mt20" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs20 fw600" }, "場所コンバーターを追加")
], -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", null, "変更する場所の項目を選択してください。", -1)
const _hoisted_57 = {
  key: 10,
  class: "appointmentContent"
}
const _hoisted_58 = { key: 11 }
const _hoisted_59 = { key: 12 }
const _hoisted_60 = { key: 13 }
const _hoisted_61 = { key: 14 }
const _hoisted_62 = { key: 15 }
const _hoisted_63 = { key: 16 }
const _hoisted_64 = { key: 17 }
const _hoisted_65 = { key: 18 }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadImageButton = _resolveComponent("UploadImageButton")!
  const _component_SelectableImage = _resolveComponent("SelectableImage")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_AttendeesTable = _resolveComponent("AttendeesTable")!
  const _component_AddressBookContent = _resolveComponent("AddressBookContent")!
  const _component_LeftNavPanelCalendarContent = _resolveComponent("LeftNavPanelCalendarContent")!
  const _component_AppointmentInfoContent = _resolveComponent("AppointmentInfoContent")!
  const _component_MailEditContent = _resolveComponent("MailEditContent")!
  const _component_LeftNavPanelAppealContent = _resolveComponent("LeftNavPanelAppealContent")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_LblueListContent = _resolveComponent("LblueListContent")!
  const _component_SelectLocationsList = _resolveComponent("SelectLocationsList")!
  const _component_FormFieldEditContent = _resolveComponent("FormFieldEditContent")!
  const _component_FormFieldsList = _resolveComponent("FormFieldsList")!
  const _component_LocationConvertersList = _resolveComponent("LocationConvertersList")!
  const _component_LeftNavPanelPPTosSettingsContent = _resolveComponent("LeftNavPanelPPTosSettingsContent")!
  const _component_ThanksPageEditContent = _resolveComponent("ThanksPageEditContent")!
  const _component_ProviderEventEditContent = _resolveComponent("ProviderEventEditContent")!
  const _component_InstantRoomTextEditContent = _resolveComponent("InstantRoomTextEditContent")!
  const _component_TemplateForAiEditContent = _resolveComponent("TemplateForAiEditContent")!
  const _component_AvailableFieldsForAiEditContent = _resolveComponent("AvailableFieldsForAiEditContent")!
  const _component_FieldConvertersList = _resolveComponent("FieldConvertersList")!
  const _component_GoogleSpreadSheetFileSelector = _resolveComponent("GoogleSpreadSheetFileSelector")!
  const _component_LeftNavPanelChukaiMenu = _resolveComponent("LeftNavPanelChukaiMenu")!
  const _component_ModalTemplates = _resolveComponent("ModalTemplates")!
  const _component_ImageBoardModal = _resolveComponent("ImageBoardModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", {
      class: _normalizeClass(`leftNavPanel ofs ${_ctx.isSP ? `pad10` : `pad10`} posFi noscroll`)
    }, [
      _createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/icons/close_panel.png`),
        width: "36",
        height: "36",
        class: "fr pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePanel && _ctx.closePanel(...args)))
      }, null, 8, _hoisted_1),
      _hoisted_2,
      (_ctx.panelType == `image`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "pointer fr fw600 fs13 mt30 underline skyblue",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteHeaderImage && _ctx.deleteHeaderImage(...args)))
                }, " ヘッダー画像を削除 "),
                _hoisted_7,
                _createVNode(_component_UploadImageButton, {
                  onClickButton: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeImageTab(`custom`)))
                }),
                _hoisted_8,
                _createElementVNode("div", null, [
                  _hoisted_9,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sampleImages, (file, fileindex) => {
                    return (_openBlock(), _createBlock(_component_SelectableImage, {
                      key: fileindex,
                      file: file,
                      width: 120,
                      class: "ofh fl posRe",
                      onChange: _ctx.changeImage,
                      onMouseoverImage: _ctx.mouseoverImage,
                      onMouseleaveImage: _ctx.mouseleaveImage
                    }, null, 8, ["file", "onChange", "onMouseoverImage", "onMouseleaveImage"]))
                  }), 128)),
                  _hoisted_10,
                  _hoisted_11
                ])
              ])
            ]),
            _hoisted_12
          ]))
        : (_ctx.panelType == `attendees`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_ctx.rcm.appo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    (_ctx.Util.isPresent(_ctx.rcm.attendees) && _ctx.rcm.attendees.length >= 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _hoisted_18,
                          _createVNode(_component_Switcher, {
                            value: "type[busyness]",
                            name: "カレンダー連携",
                            checked: _ctx.rcm.appo ? _ctx.rcm.appo.required_owner_participation : true,
                            display: "true",
                            class: "checkUsingCal fl",
                            onSelect: _ctx.linkCal
                          }, null, 8, ["checked", "onSelect"])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_19,
                    _hoisted_20,
                    (!_ctx.rcm.appo.required_owner_participation && _ctx.rm.chukaiAstag && _ctx.rm.chukaiAstag.id == `newId`)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                      : _createCommentVNode("", true),
                    _createVNode(_component_AttendeesTable, {
                      room: _ctx.rcm.room,
                      members: _ctx.rcm.members,
                      onDeleteMember: _ctx.deleteMember,
                      onEditAttendee: _ctx.editAttendee,
                      onUpdateMembers: _ctx.updateMembers
                    }, null, 8, ["room", "members", "onDeleteMember", "onEditAttendee", "onUpdateMembers"]),
                    _hoisted_24,
                    _createVNode(_component_AddressBookContent, {
                      members: _ctx.rcm.members,
                      currentMember: _ctx.currentMember,
                      editOrNewForm: _ctx.editOrNewForm,
                      showEditButton: false,
                      showNewButton: true,
                      onAddAttendee: _ctx.addAttendee,
                      class: _normalizeClass(`ofs`),
                      style: `max-height:600px;`
                    }, null, 8, ["members", "currentMember", "editOrNewForm", "onAddAttendee"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : ([`astag`, `rules_by_ai_astag`, `subAstag`].includes(_ctx.panelType))
            ? (_openBlock(), _createBlock(_component_LeftNavPanelCalendarContent, {
                key: 2,
                panelType: _ctx.panelType,
                onClosePanel: _ctx.closePanel
              }, null, 8, ["panelType", "onClosePanel"]))
            : (_ctx.panelType == `appo`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", null, [
                    _hoisted_26,
                    _hoisted_27,
                    _createVNode(_component_AppointmentInfoContent, {
                      members: _ctx.rcm.members,
                      appoStatus: _ctx.appoStatus,
                      onUpdateAppo: _ctx.updateAppo,
                      titles: _ctx.titles,
                      appo: _ctx.rcm.appo,
                      from: `room_settings`,
                      rs: _ctx.rcm.room_setting,
                      onUpdateStepSize: _ctx.updateStepSize,
                      ref: "AppointmentInfo"
                    }, null, 8, ["members", "appoStatus", "onUpdateAppo", "titles", "appo", "rs", "onUpdateStepSize"]),
                    _hoisted_28
                  ])
                ]))
              : (_ctx.panelType == `message`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    (_ctx.canSendSMS)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3 mt2",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeSendChannelMode && _ctx.changeSendChannelMode(...args)))
                        }, [
                          (_ctx.rcm.showSMSField)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                                _createElementVNode("img", {
                                  src: _ctx.$getAssetImageUrl(`/assets/home/mail_icon.png`),
                                  width: "14",
                                  height: "15",
                                  class: "fl mr5"
                                }, null, 8, _hoisted_31),
                                _createTextVNode("メールに切り替え")
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                _createElementVNode("img", {
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/call.png`),
                                  width: "14",
                                  height: "15",
                                  class: "fl mr5"
                                }, null, 8, _hoisted_33),
                                _createTextVNode(" SMSに切り替え")
                              ])),
                          _hoisted_34
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_35,
                    _createElementVNode("div", null, [
                      _hoisted_36,
                      _hoisted_37,
                      _createVNode(_component_MailEditContent, { ref: "MailEditContent" }, null, 512)
                    ])
                  ]))
                : (_ctx.rcm.appeal_content && _ctx.panelType == `headerContent`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createVNode(_component_LeftNavPanelAppealContent)
                    ]))
                  : (_ctx.rcm.appo && _ctx.panelType == `locations`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("div", null, [
                          _hoisted_40,
                          _hoisted_41,
                          (_ctx.rcm.appo.location_select_type == `registrable`)
                            ? (_openBlock(), _createBlock(_component_TextfieldTag, {
                                key: 0,
                                placeholder: "東京都千代田区飯田橋4-25-1 セントラルプラザ2F",
                                style: {"height":"50px"},
                                class: "fl fs14 roundForm mw100 mt20",
                                value: _ctx.rcm.appo.location_name,
                                onInputValue: _ctx.inputLocationName
                              }, null, 8, ["value", "onInputValue"]))
                            : _createCommentVNode("", true),
                          _hoisted_42,
                          (_ctx.locationNames && _ctx.rcm.appo.location_select_type == `registrable`)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_43, [
                                _hoisted_44,
                                _hoisted_45,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationNames, (loc, locindex) => {
                                  return (_openBlock(), _createBlock(_component_LblueListContent, {
                                    key: locindex,
                                    class: _normalizeClass(`fl mr10 mb10`),
                                    name: loc,
                                    value: loc,
                                    type: `underline`,
                                    display: true,
                                    showDeleteButton: false,
                                    onClickContent: ($event: any) => (_ctx.setLocationInfo(loc))
                                  }, null, 8, ["name", "value", "onClickContent"]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_46,
                          _createVNode(_component_SelectLocationsList, {
                            loctags: _ctx.loctags,
                            appo: _ctx.rcm.appo,
                            astag: _ctx.rcm.astag,
                            onSelect: _ctx.selectLocations,
                            class: "mt20"
                          }, null, 8, ["loctags", "appo", "astag", "onSelect"])
                        ])
                      ]))
                    : (_ctx.panelType == `field`)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createElementVNode("div", null, [
                            _hoisted_48,
                            _hoisted_49,
                            _createVNode(_component_FormFieldEditContent, {
                              ref: `FormFieldEditContent`,
                              editingField: _ctx.field,
                              class: "mt20",
                              onUpdateFieldFromChild: _ctx.updateFieldFromChild,
                              showImageBoardModal: _ctx.showImageBoardModal
                            }, null, 8, ["editingField", "onUpdateFieldFromChild", "showImageBoardModal"])
                          ])
                        ]))
                      : (_ctx.panelType == `add_field`)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            _createElementVNode("div", null, [
                              _hoisted_51,
                              _hoisted_52,
                              _createVNode(_component_FormFieldsList, {
                                onSelect: _ctx.selectField,
                                class: "mt20"
                              }, null, 8, ["onSelect"])
                            ])
                          ]))
                        : (_ctx.panelType == `location_converters`)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                              _createElementVNode("div", null, [
                                _hoisted_54,
                                _hoisted_55,
                                _hoisted_56,
                                _createVNode(_component_LocationConvertersList, {
                                  onSelect: _ctx.selectLocationConverter,
                                  class: "mt20"
                                }, null, 8, ["onSelect"])
                              ])
                            ]))
                          : (_ctx.rcm.room_setting && _ctx.panelType == `pptos`)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                _createVNode(_component_LeftNavPanelPPTosSettingsContent, {
                                  room: _ctx.rcm.room,
                                  updateRoomSetting: _ctx.updateRoomSetting
                                }, null, 8, ["room", "updateRoomSetting"])
                              ]))
                            : (_ctx.panelType == `thanks_page`)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                  _createVNode(_component_ThanksPageEditContent, {
                                    room: _ctx.rcm.room,
                                    updateRoomSetting: _ctx.updateRoomSetting
                                  }, null, 8, ["room", "updateRoomSetting"])
                                ]))
                              : (_ctx.panelType == `provider_event`)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    _createVNode(_component_ProviderEventEditContent, {
                                      room: _ctx.rcm.room,
                                      updateRoomSetting: _ctx.updateRoomSetting
                                    }, null, 8, ["room", "updateRoomSetting"])
                                  ]))
                                : (_ctx.panelType == `instant_room_text`)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                      _createVNode(_component_InstantRoomTextEditContent, {
                                        room: _ctx.rcm.room,
                                        updateRoomSetting: _ctx.updateRoomSetting
                                      }, null, 8, ["room", "updateRoomSetting"])
                                    ]))
                                  : (_ctx.panelType == `template_for_ai`)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                        _createVNode(_component_TemplateForAiEditContent, {
                                          room: _ctx.rcm.room,
                                          updateRoomSetting: _ctx.updateRoomSetting,
                                          onClosePanel: _ctx.closePanel
                                        }, null, 8, ["room", "updateRoomSetting", "onClosePanel"])
                                      ]))
                                    : (_ctx.panelType == `available_fields_for_ai`)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                          _createVNode(_component_AvailableFieldsForAiEditContent, {
                                            room: _ctx.rcm.room,
                                            updateRoomSetting: _ctx.updateRoomSetting,
                                            onClosePanel: _ctx.closePanel
                                          }, null, 8, ["room", "updateRoomSetting", "onClosePanel"])
                                        ]))
                                      : (_ctx.panelType == `field_converter`)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                            _createVNode(_component_FieldConvertersList, { canEdit: true })
                                          ]))
                                        : (_ctx.panelType == `google_spread_sheet_file_selector`)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                              _createVNode(_component_GoogleSpreadSheetFileSelector)
                                            ]))
                                          : (_ctx.panelType == `chukai_menu`)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                                _createVNode(_component_LeftNavPanelChukaiMenu)
                                              ]))
                                            : _createCommentVNode("", true),
      _hoisted_66
    ], 2),
    _createVNode(_component_ModalTemplates, {
      class: "posAb",
      onDecideTemplate: _ctx.decideTemplate
    }, null, 8, ["onDecideTemplate"]),
    _createVNode(_component_ImageBoardModal, {
      class: _normalizeClass(`posAb`),
      currentImageUrl: _ctx.currentImageUrl,
      title: `画像を選択`,
      onSelect: _ctx.selectFile
    }, null, 8, ["currentImageUrl", "onSelect"])
  ]))
}